<div class="wrapper">
  <div class="cuerpo">

    <h1 class="tp-navandu line-navandu">CONSUMO</h1>

    @if (loading) {
    <app-spinner></app-spinner>
    } @else {
    <div class="boxes">
      <div class="box">
        <h3>Numero de documentos:  <span>{{ stats.numDocuments }}</span></h3>
        
     
        <h3>Documentos por estado:</h3>

        <div>
          <span class="label">Pendiente:</span>
          <span>{{ stats.status.pending }}</span>
        </div>
        <div>
          <span class="label">Firmado:</span>
          <span>{{ stats.status.signed }}</span>
        </div>
        <div>
          <span class="label">Rechazado:</span>
          <span>{{ stats.status.rejected }}</span>
        </div>
        <div>
          <span class="label">Generando:</span>
          <span>{{ stats.status.generating }}</span>
        </div>

        <div>
          <span class="label">Asignado:</span>
          <span>{{ stats.status.assigned }}</span>
        </div>
        <div>
          <span class="label">Error:</span>
          <span>{{ stats.status.error }}</span>
        </div>
        <div>
          <span class="label">Expirado:</span>
          <span>{{ stats.status.expired }}</span>
        </div>
     
        <h3>Documentos por tipo:</h3>
        <div>
          <span class="label">Analógico:</span>
          <span>{{ stats.type.analog }}</span>
        </div>
        <div>
          <span class="label">Biométrico:</span>
          <span>{{ stats.type.biometric }}</span>
        </div>
        <div>
          <span class="label">Remote:</span>
          <span>{{ stats.type.remote }}</span>
        </div>
    
       
      </div>

      <div class="box">
         <h3>Numero de plantillas: <span>{{ stats.numTemplates }}</span></h3>
        
        <h3>Documentos por plantilla:</h3>
        @for (doc of stats.documentsByTemplate; track doc) {
        <div>
          <span class="label">{{ doc.name }}:</span>
          <span>{{ doc.total }}</span>
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>